.a1{justify-content:center;}